import log from 'salvo-lite/log'
import axios from 'axios'

class QuickBuy {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-quick-buy'))
        this._selectedVariant = null

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._options.swatches.forEach(swatch => {
            const swatchElement = document.querySelector(swatch)

            let swatches
            if (swatchElement) {
                swatches = swatchElement.querySelectorAll('.swatch')
            }

            if (swatches && swatches.length > 1) {
                swatches.forEach(swatch => {
                    swatch.addEventListener('click', () => {
                        swatches.forEach(_swatch => _swatch.classList.remove('checked'))
                        swatch.classList.add('checked')
                        this.changeVariant(swatches)
                    })
                })
            } else {
                this._selectedVariant = this._options.productHold
            }
        })

        this._elem.addEventListener('click', async () => {
            this.addProductAndRedirect(this._selectedVariant)
        })
    }

    changeVariant (swatches) {
        let color
        swatches.forEach(swatch => {
            if (swatch.classList.contains('checked')) {
                color = swatch.id
            }
        })

        const variants = this._options.variants

        this._selectedVariant = variants.filter(variant => {
            if (variant.options.includes(color)) {
                return variant
            }
        })[0].id
    }

    async addProductAndRedirect (id) {
        await axios.post('/cart/add.js', {
            items: [ { id: id, quantity: 1 } ]
        })

        window.location.href = window.location.origin + '/checkout'
    }
}

export default QuickBuy



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuickBuy.js